'use strict';

module.exports = '3.25.0';
